import { faEthereum } from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { LabelM, LabelXS } from 'atoms/typography';
import { Dots } from 'atoms/ui/Dots';
import { useIntlContext } from 'contexts/intl';

import { useEthBalance } from './useEthBalance';

const fallback = '0 ETH';

type Props = { collapsed?: boolean };
export const EthBalance = ({ collapsed }: Props) => {
  const { formatNumber } = useIntlContext();
  const { hideBalance, balanceInEth } = useEthBalance({
    hideSymbol: collapsed,
  });

  if (collapsed) {
    return (
      <Vertical gap={0.5} center>
        <FontAwesomeIcon icon={faEthereum} />
        {typeof balanceInEth === 'string' && (
          <LabelXS bold>
            {formatNumber(parseFloat(balanceInEth), {
              notation: 'compact',
              compactDisplay: 'short',
              maximumFractionDigits: 2,
            })}
          </LabelXS>
        )}
      </Vertical>
    );
  }

  return hideBalance ? (
    <Horizontal center>
      <FontAwesomeIcon icon={faEthereum} />
      <Horizontal gap={0.5}>
        <Dots count={3} size="small" />
      </Horizontal>
    </Horizontal>
  ) : (
    <LabelM bold>{balanceInEth || fallback}</LabelM>
  );
};
